import { useState, useEffect } from 'react'

const useClipboardStatus = () => {
  const [clipboardText, setClipboardText] = useState('')
  const [hasClipboardData, setHasClipboardData] = useState(false)

  const checkClipboard = async () => {
    try {
      const text = await navigator.clipboard.readText()
      setClipboardText(text)
      setHasClipboardData(text.length > 0)
    } catch (error) {
      console.error('Clipboard access denied:', error)
    }
  }

  useEffect(() => {
    const handleFocus = () => checkClipboard()
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        checkClipboard()
      }
    }

    window.addEventListener('focus', handleFocus)
    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      window.removeEventListener('focus', handleFocus)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return { clipboardText, hasClipboardData, checkClipboard }
}

export default useClipboardStatus
